











import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';
import { BaseHeading, BaseList, BaseListItem, BaseMenuItem } from '@shared/ui';

import { SimpleMenuLink } from '../types';

export default defineComponent({
  name: 'AppFooterMenuItem',
  components: { BaseHeading, BaseList, BaseListItem, BaseMenuItem },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array as PropType<SimpleMenuLink[]>,
      default: () => [],
    },
  },
  setup() {
    const getLink = (link: SimpleMenuLink) => sanitizeLinkUrl(link.link_href?.cached_url);

    return {
      getLink,
    };
  },
});
